module.exports = __webpack_public_path__ + "src/assets/img/geo-white.57a33efb.svg";